import { createSlice } from "@reduxjs/toolkit";
import {
  addNewLead,
  verifyOtp,
} from "./thunk";

export const initialState: any = {
  crmcontacts: [],
  companies: [],
  isLeadCreated: false,
  deals: [],
  leads: [],
  error: {},
  isopen: false,
  publicGuid: "",
  client_id: "",
  SoapResponse:false
};

const LeadSlice = createSlice({
  name: "public_form",
  initialState,

  reducers: {
    setOtpModal(state) {
      state.isopen = false;
    },
    clientDataFetchedSuccessful(state, action) {
      console.log("action of client",action)
      state.client_id = action.payload.clientData.client_id;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verifyOtp.fulfilled, (state: any, action: any) => {
      state.isopen = false;
    });
    builder.addCase(addNewLead.fulfilled, (state: any, action: any) => {
      state.leads.unshift(action.payload);
      state.isLeadCreated = true;
      state.isLeadsAdd = true;
      state.isLeadsAddFail = false;
      state.isopen = true;
      console.log("action", action, action.payload.data.guid);
      state.publicGuid = action.payload.data.guid;
      state.SoapResponse = action.payload.data.saopres;
    });

    builder.addCase(addNewLead.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
      state.isLeadsAdd = false;
      state.isLeadsAddFail = true;
    });
  },
});
export const { setOtpModal, clientDataFetchedSuccessful } = LeadSlice.actions;

export default LeadSlice.reducer;
